import { ORDER_STATUS } from '~/constants/order';

export interface IResponseTakerGoSettings {
  yallow_api_key: string;
  takergo_order_status: string;
  dook_api_key: string;
  on_takergo: boolean;
  statuses: Record<ORDER_STATUS, string>;
}

export const takerGoSettingsCast = (data: IResponseTakerGoSettings) => ({
  orderStatus: String(data.takergo_order_status) as ORDER_STATUS,
  yallowApiKey: String(data.yallow_api_key || ''),
  takerFleetApiKey: String(data.dook_api_key || ''),
});
export type TTakerGoSettings = ReturnType<typeof takerGoSettingsCast>;

export interface ITakerGoSettingsErrors {
  takerFleetApi?: string;
  yallowApiKey?: string;
}
